export default {
  buttonText: 'More information',
};
